import FormulariDades from './FormulariDades';
import FormulariEntitats from './FormulariEntitats';
import FormulariResposta from './FormulariResposta';
import FormulariMalalties from './FormulariMalalties';

type FormulariMaratoProps = {
    nom?: string;
    [key: string]: any;
};

export default function Component(props: FormulariMaratoProps) {
    const { nom } = props;

    switch (nom) {
        case 'resposta':
            return <FormulariResposta {...props} />;
        case 'form_faq':
            return <FormulariEntitats {...props} />;
        case 'registre':
            return <FormulariMalalties {...props} />;
        case 'Participa':
        default:
            return <FormulariDades {...props} />;
    }
}
